/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { DbTestReq } from '../models/db-test-req';
import { HttpTestReq } from '../models/http-test-req';

@Injectable({ providedIn: 'root' })
export class ServerService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiServerDbTestPost()` */
  static readonly ApiServerDbTestPostPath = '/api/server/db-test';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiServerDbTestPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiServerDbTestPost$Response(
    params?: {
      body?: DbTestReq
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<string>> {
    const rb = new RequestBuilder(this.rootUrl, ServerService.ApiServerDbTestPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<string>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiServerDbTestPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiServerDbTestPost(
    params?: {
      body?: DbTestReq
    },
    context?: HttpContext
  ): Observable<string> {
    return this.apiServerDbTestPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

  /** Path part for operation `apiServerHttpTestPost()` */
  static readonly ApiServerHttpTestPostPath = '/api/server/http-test';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiServerHttpTestPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiServerHttpTestPost$Response(
    params?: {
      body?: HttpTestReq
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<string>> {
    const rb = new RequestBuilder(this.rootUrl, ServerService.ApiServerHttpTestPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<string>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiServerHttpTestPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiServerHttpTestPost(
    params?: {
      body?: HttpTestReq
    },
    context?: HttpContext
  ): Observable<string> {
    return this.apiServerHttpTestPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

}
